/* Carrito Omelva.
   Talla y color van como propiedades de linea, una pareja por unidad, porque
   una variante solo puede guardar una talla y los packs traen varias unidades.
   La clave la construye la seccion como 'Unidad N · Talla', exactamente igual
   que la ficha del producto; si las dos no coinciden, el carrito no encuentra
   lo que la clienta ya eligio y bloquea el pago sin motivo.
   /cart/change.js reemplaza TODAS las propiedades de la linea, asi que en cada
   cambio se envian todas juntas. */
(function () {
  var raiz = document.querySelector('[data-omc]');
  if (!raiz) return;

  var textoGuardado = raiz.dataset.textoGuardado || 'Guardado';
  var textoGuardando = raiz.dataset.textoGuardando || 'Guardando...';
  var exigir = raiz.dataset.exigir === 'true';

  function lineas() {
    return [].slice.call(raiz.querySelectorAll('[data-omc-linea]'));
  }

  function indiceDe(linea) {
    return lineas().indexOf(linea) + 1;
  }

  function pedir(url, cuerpo) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  /* ---------- propiedades por unidad ---------- */

  function estado(linea, texto, visible) {
    var e = linea.querySelector('[data-omc-estado]');
    if (!e) return;
    e.textContent = texto;
    e.classList.toggle('on', !!visible);
  }

  function recogerPropiedades(linea) {
    var props = {};
    linea.querySelectorAll('[data-omc-prop]').forEach(function (s) {
      props[s.dataset.omcProp] = s.value || '';
    });
    return props;
  }

  /* Tallas, colores o parejas talla/color sin stock (metacampo custom.agotados del producto, p. ej. «6XL, Morado,
     XL/Beige»; Shopify no lleva stock por talla y color de la braguita): no se pueden elegir y, si una prenda ya
     guardada lo tiene, cuenta como pendiente. */
  function norma(v) { return String(v || '').toLowerCase().replace(/\s*\/\s*/g, '/').replace(/\s+/g, ' ').trim(); }
  function marcarAgotados(linea) {
    var caja = linea.querySelector('[data-omc-agotados]');
    var lista = caja ? caja.getAttribute('data-omc-agotados').split(/[,\n;]/).map(norma).filter(Boolean) : [];
    if (!lista.length) return;
    function no(a, b) {
      a = norma(a); b = norma(b);
      return lista.indexOf(a) >= 0 || lista.indexOf(b) >= 0 || (!!a && !!b && (lista.indexOf(a + '/' + b) >= 0 || lista.indexOf(b + '/' + a) >= 0));
    }
    linea.querySelectorAll('.omc-uni').forEach(function (u) {
      var s = u.querySelectorAll('select');
      if (s.length < 2) return;
      [[s[0], s[1], true], [s[1], s[0], false]].forEach(function (p) {
        [].forEach.call(p[0].options, function (op) {
          if (!op.value) return;
          if (op.getAttribute('data-base') === null) op.setAttribute('data-base', op.textContent);
          var x = p[2] ? no(op.value, p[1].value) : no(p[1].value, op.value);
          op.disabled = x;
          op.textContent = op.getAttribute('data-base') + (x ? ' · Agotado' : '');
        });
      });
    });
  }
  function pendiente(s) { var op = s.options[s.selectedIndex]; return !s.value || !!(op && op.disabled); }

  function faltanPorElegir(linea) {
    var faltan = 0;
    marcarAgotados(linea);
    linea.querySelectorAll('[data-omc-prop]').forEach(function (s) {
      var vacio = pendiente(s);
      s.classList.toggle('falta', vacio);
      if (vacio) faltan += 1;
    });
    var aviso = linea.querySelector('[data-omc-aviso]');
    if (aviso) aviso.style.display = faltan === 0 ? 'none' : '';
    return faltan;
  }

  function revisarTodo() {
    var boton = document.querySelector('[data-omc-pagar]');
    var bloqueo = document.querySelector('[data-omc-bloqueo]');
    lineas().forEach(marcarAgotados);
    if (!boton) return;
    if (!exigir) {
      boton.disabled = false;
      if (bloqueo) bloqueo.style.display = 'none';
      return;
    }
    var pendientes = 0;
    lineas().forEach(function (l) {
      l.querySelectorAll('[data-omc-prop]').forEach(function (s) { if (pendiente(s)) pendientes += 1; });
    });
    boton.disabled = pendientes > 0;
    if (bloqueo) bloqueo.style.display = pendientes > 0 ? 'block' : 'none';
  }

  var temporizadores = {};

  function guardarLinea(linea) {
    var idx = indiceDe(linea);
    if (idx < 1) return;
    faltanPorElegir(linea);
    revisarTodo();
    estado(linea, textoGuardando, true);
    clearTimeout(temporizadores[idx]);
    /* Sin la cantidad, /cart/change.js deja la línea en 1 al cambiar propiedades
       (2 packs pasaban a 1 con las unidades de los 2 anotadas). Se manda siempre. */
    var campo = linea.querySelector('[data-omc-cantidad]');
    var q = campo ? parseInt(campo.value, 10) : NaN;
    var cuerpo = { line: idx, properties: recogerPropiedades(linea) };
    if (isFinite(q) && q > 0) cuerpo.quantity = q;
    temporizadores[idx] = setTimeout(function () {
      pedir('/cart/change.js', cuerpo)
        .then(function () {
          estado(linea, textoGuardado, true);
          setTimeout(function () { estado(linea, textoGuardado, false); }, 2200);
        })
        .catch(function () { estado(linea, '', false); });
    }, 350);
  }

  raiz.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-omc-prop]');
    if (!sel) return;
    var linea = sel.closest('[data-omc-linea]');
    if (linea) guardarLinea(linea);
  });

  /* ---------- cantidad y eliminar ---------- */

  function topeDe(campo) {
    var m = parseInt(campo && campo.getAttribute('max'), 10);
    return isFinite(m) && m > 0 ? m : 10;
  }

  /* Al cambiar la cantidad se mandan también las tallas y colores elegidos, recortados a las prendas que quedan:
     así no se pierde lo que aún no se había guardado y no quedan tallas de prendas que ya no se compran. */
  function cambiarCantidad(linea, cantidad) {
    var idx = indiceDe(linea);
    if (idx < 1) return;
    var cuerpo = { line: idx, quantity: cantidad };
    var base = parseInt(linea.getAttribute('data-base'), 10) || 0;
    if (base && cantidad > 0) {
      var tope = base * cantidad, props = {};
      linea.querySelectorAll('[data-omc-prop]').forEach(function (s) {
        var m = /^Unidad (\d+) · /.exec(s.dataset.omcProp);
        if (m && +m[1] <= tope) props[s.dataset.omcProp] = s.value || '';
      });
      cuerpo.properties = props;
    }
    pedir('/cart/change.js', cuerpo)
      .then(function () { window.location.reload(); })
      .catch(function () {
        estado(linea, 'No se ha podido cambiar. Vuelve a intentarlo.', true);
      });
  }

  /* «Te sale más barato en pack»: lo cambia om-mejora-pack.js y luego se recarga con los importes de Shopify. */
  raiz.addEventListener('click', function (e) {
    var b = e.target.closest('[data-om-mejora-btn]');
    if (!b || !window.omMejoraPack) return;
    window.omMejoraPack(b.closest('[data-om-mejora]'), function () { window.location.reload(); });
  });

  raiz.addEventListener('click', function (e) {
    var menos = e.target.closest('[data-omc-menos]');
    var mas = e.target.closest('[data-omc-mas]');
    var quitar = e.target.closest('[data-omc-quitar]');
    if (!menos && !mas && !quitar) return;

    var linea = e.target.closest('[data-omc-linea]');
    if (!linea) return;

    if (quitar) { cambiarCantidad(linea, 0); return; }

    var campo = linea.querySelector('[data-omc-cantidad]');
    var tope = topeDe(campo);
    var actual = parseInt(campo.value, 10) || 1;
    var v = mas ? actual + 1 : actual - 1;
    if (v < 1) v = 1;
    if (v > tope) v = tope;
    if (v === actual) return;
    campo.value = v;
    cambiarCantidad(linea, v);
  });

  raiz.addEventListener('change', function (e) {
    var campo = e.target.closest('[data-omc-cantidad]');
    if (!campo) return;
    var linea = campo.closest('[data-omc-linea]');
    var tope = topeDe(campo);
    var v = parseInt(campo.value, 10);
    if (!isFinite(v) || v < 1) v = 1;
    if (v > tope) v = tope;
    campo.value = v;
    cambiarCantidad(linea, v);
  });

  /* ---------- nota del pedido ---------- */

  var nota = raiz.querySelector('[data-omc-nota]');
  if (nota) {
    var tNota = null;
    nota.addEventListener('input', function () {
      clearTimeout(tNota);
      tNota = setTimeout(function () { pedir('/cart/update.js', { note: nota.value }); }, 600);
    });
  }

  /* ---------- aviso al intentar pagar sin elegir ---------- */

  var boton = document.querySelector('[data-omc-pagar]');
  if (boton) {
    boton.addEventListener('click', function (e) {
      if (!exigir) return;
      var primeraFalta = null;
      lineas().forEach(function (l) {
        if (faltanPorElegir(l) > 0 && !primeraFalta) primeraFalta = l;
      });
      if (primeraFalta) {
        e.preventDefault();
        primeraFalta.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var s = primeraFalta.querySelector('.falta');
        if (s) s.focus({ preventScroll: true });
      }
    });
  }

  lineas().forEach(function (l) { faltanPorElegir(l); });
  revisarTodo();
})();